import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";
import { OnboardingSteps } from "../OnboardingGuide";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingHighlightHintFlow = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const currentStep = flow?.getCurrentStep();

  if (!flow?.isCompleted && currentStep?.id as OnboardingSteps === "highlight") {
    console.log("highlight hint");
    return (
      <OnboardingFlow>
        <Frigade.Tour
          flowId={config.frigade.flows.highlightHint}
          defaultOpen={true}
          side="right"
          align="start"
        />
      </OnboardingFlow>
    );
  }
};

export default OnboardingHighlightHintFlow;